import React, { useEffect, useState } from "react";
import { useAxiosContext } from "../../../../context/AxiosContext";
import { useAppBlocksContext } from "../../../../context/AppBlocksContext";

import { useNavigationContext } from "../../../../context/NavigationContext";
import DetailsviewPreview from "../../../../components/BuilderComponents/Preview/DetailsviewPreview";
import Button from "../../../../components/FormComponents/Button";
import { searchArray } from "../../../../commonFunctions/arrayFunc";
import Input from "../../../../components/FormComponents/Input";
import { BASE_URL } from "../../../../constant/constant";
import MaterialIcon from "../../../../components/BuilderComponents/MaterialIcon";
import { generateObjectId } from "../../../../utils/objectIdUtils";

const TemplateModal = ({ closeModal }) => {
  const [allTemplates, setAllTemplates] = useState([]);
  const { axiosInstance, handleError } = useAxiosContext();
  const [selectedTemplate, setSelectedTemplate] = useState({});
  const [searchQuery, setSearchQuery] = useState("");

  const { getDetailviewConfig, applicationBlockData } = useAppBlocksContext();
  const { getInitialRederConfig } = useNavigationContext();

  useEffect(() => {
    fetchAllTemplates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const fetchAllTemplates = async () => {
    try {
      const { data } = await axiosInstance.get(`/sysconfigs/type/detailsview`);
      setAllTemplates(data);
    } catch (error) {
      handleError(error);
    }
  };
  const handleSelectTemplate = (value) => {
    const getTheme = allTemplates.find((template) => template.id === value);
    if (getTheme) {
      setSelectedTemplate(getTheme);
    } else {
      setSelectedTemplate("");
    }
  };

  const importTemplate = () => {
    const currentData = getDetailviewConfig();
    let newString = JSON.stringify(selectedTemplate.config, null, 2);
    selectedTemplate.config.unique_ids.forEach((id) => {
      const regex = new RegExp(id, "g");
      newString = newString.replace(regex, generateObjectId());
    });
    const newConfig = JSON.parse(newString);
    let maxY = 0;
    currentData.elements.forEach((element) => {
      if (element.grid.y > maxY) {
        maxY = element.grid.y;
      }
    });

    const updatedNewConfig = newConfig.elements.map((element) => {
      element.grid.y = maxY + element.grid.y;
      return element;
    });
    const newArray = [...currentData.elements, ...updatedNewConfig];
    const config = {
      detailsView: {
        ...applicationBlockData,
        data: {
          elements: newArray,
          table_id: applicationBlockData.data.table_id
        }
      },
      // lockData: null,
      table_type: applicationBlockData.table_type
    };
    getInitialRederConfig("detailsview", config);
    closeModal();
  };

  const goToTemplates = () => {
    setSelectedTemplate({});
  };
  const { result: filteredTemplates, err } = searchArray(allTemplates, searchQuery, ["name"]);
  if (err) return <p>Error: </p>;
  return (
    <>
      {selectedTemplate.id ? (
        <div className="import_template_preview">
          <div className="flex_row justify_between">
            <MaterialIcon name="arrow_back" className="nav_previous" onClick={() => goToTemplates()} />
            <Button onClick={importTemplate}>Import</Button>
          </div>
          <DetailsviewPreview detailviewConfig={selectedTemplate.config?.elements || []} />
        </div>
      ) : (
        <div className="flex_column" style={{ width: "69vw" }}>
          <div className="w_25 mb_3">
            <Input placeholder="Search Tempalte" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
          </div>
          <div className="template_container">
            {filteredTemplates.map((template) => (
              <div key={template.id} className="template_card" onClick={() => handleSelectTemplate(template.id)}>
                {template.config.image_data && template.config.image_data.name ? (
                  <>
                    <span className="font_weight_medium">{template.name}</span>
                    <img
                      src={`${BASE_URL}/api/v1/public/${template.config.image_data.name}`}
                      alt={"template preview"}
                    />
                  </>
                ) : (
                  <span className="font_weight_medium">{template.name}</span>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default TemplateModal;
